import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './header.scss';

const PrevIcon = () => {
        return (
            <svg viewBox='0 0 9 16'>
                <path
                    d='M1.54890057,7.74450284 L8.90617827,15.1017805 L8.13172798,15.8762308 L0.387225142,8.13172798 L3.31290551e-13,7.74450284 L7.74450284,-2.98983061e-13 L8.51895313,0.774450284 L1.54890057,7.74450284 Z'
                    fill='#5F6570'
                />
            </svg>
        );
    },

    Header = props => {
        const {
                next,
                titlePre,
                title,
                idPrefix
            } = props,
            nextClasses = classNames({
                'ht-header-next': true,
                'ht-header-next--disabled': next && next.disabled
            });

        return (
            <div className='ht-header'>
                <div className='ht-header-inner'>
                    <div className='ht-header-content'>
                        <h2 className='ht-header-title'>
                            <span>{titlePre}</span>
                            {title}
                        </h2>
                        {next && (
                            <button
                                type='button'
                                id={`${idPrefix}-header-next`}
                                className={nextClasses}
                                disabled={next.disabled}
                                onClick={e => next.onClick(e)}
                            >
                                <PrevIcon />
                                Next
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    };

Header.defaultProps = {
    next: false,
    prev: false,
    email: false
};

Header.propTypes = {
    idPrefix: PropTypes.string.isRequired,
    titlePre: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    next: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};

export default Header;
